import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Alert,
} from "@mui/material";
import { AppUrl } from "../../utils/config";

const UploadAlert = ({ open, onClose, response, label = "Data" }) => {
    if (!response) return null;

    const { msg, errorfile, torder, forder, sorder, errorFeed } = response;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Upload Status</DialogTitle>
            <DialogContent dividers>
                {errorfile ? (
                    <>
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {msg || "There are issues in the uploaded file."}
                        </Alert>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Total {label}</TableCell>
                                    <TableCell>Failed {label}</TableCell>
                                    <TableCell>Successful {label}</TableCell>
                                    <TableCell>Error Feeds</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{torder}</TableCell>
                                    <TableCell>{forder}</TableCell>
                                    <TableCell>{sorder}</TableCell>
                                    <TableCell>{errorFeed}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>

                        <Button
                            variant="contained"
                            color="error"
                            sx={{ mt: 2 }}
                            onClick={() => window.open(`${AppUrl}${errorfile}`, "_blank")}
                        >
                            Download Error File
                        </Button>
                    </>
                ) : (
                    <Alert severity="success">
                        {msg || `${label} uploaded successfully!`}
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadAlert;
